"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _RequestTool = require("./RequestTool.styled");
var _hooks = require("../../../hooks");
var _requestMessages = require("../requestMessages");
const NotifyUsRender = _ref => {
  let {
    code
  } = _ref;
  const getMessageFromKey = (0, _requestMessages.getMessages)((0, _hooks.useLocale)());
  const list = getMessageFromKey("".concat(code, ".list"));
  const description = getMessageFromKey("".concat(code, ".description"));
  return /*#__PURE__*/_react.default.createElement(_RequestTool.MainContainer, null, /*#__PURE__*/_react.default.createElement(_RequestTool.Header, null, /*#__PURE__*/_react.default.createElement(_RequestTool.HeaderTitle, null, getMessageFromKey("".concat(code, ".title"))), /*#__PURE__*/_react.default.createElement(_RequestTool.HeaderSubtitle, null, getMessageFromKey("".concat(code, ".subtitle")))), description && /*#__PURE__*/_react.default.createElement(_RequestTool.Information, null, description), list && /*#__PURE__*/_react.default.createElement(_RequestTool.List, null, list.map(item => /*#__PURE__*/_react.default.createElement("li", {
    key: item
  }, item))));
};
var _default = exports.default = NotifyUsRender;